import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../service/common';
import { concat } from 'lodash';

const ITEM_PERPAGE = 10;
interface UserState {
    userList: any[],
    selectedUser: any,
    loadingUser: Boolean,
    totalCount: Number

}

let initialState: UserState = {
    userList: [],
    selectedUser: {},
    loadingUser: false,
    totalCount: 0


}

const getUserList: any = createAsyncThunk(
    'getUserList',
    async (data: any, { rejectWithValue }) => {
        try {
            const { search,filter, page, limit } = data;
            let requestApiUrl = `/user/list?search=${search}&filter=${filter}&limit=${limit}&page=${page}`;
            const response: any = await request('get', requestApiUrl);
           
            return { data: response.data.data, total: response.data.total };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);


const getUserById: any = createAsyncThunk(
    'getUserById',
    async (id, { rejectWithValue }) => {
        try {
            let requestApiUrl = '/user/user/' + id;
            const response: any = await request('get', requestApiUrl);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const exportAllDataByType:any=createAsyncThunk(
    'exportDataInCsv',
    async(type,{rejectWithValue})=>{
        try{
           
            let requestApiUrl=`/user/export/${type}`;
            const response: any = await request('get', requestApiUrl);
            return { data: response.data };

        }catch(err){
            return rejectWithValue
        }
    }
)
const addPermission: any = createAsyncThunk(
    'addPermission',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { data, id } = datas
            let requestApiUrl = '/user/permission/' + id;
            const response: any = await request('put', requestApiUrl, data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const addUser: any = createAsyncThunk(
    'addUser',
    async (data: any, { rejectWithValue }) => {
        try {
            let requestApiUrl = '/user/create';
            const response: any = await request('post', requestApiUrl, data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const editUser: any = createAsyncThunk(
    'editUser',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { data, id } = datas
            let requestApiUrl = '/user/update/' + id;
            const response: any = await request('put', requestApiUrl, data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const changeStatus: any = createAsyncThunk(
    'changeStatus',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { data, id } = datas
            let requestApiUrl = '/user/change-active-status/' + id;
            const response: any = await request('put', requestApiUrl, data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const changeMRXStatus: any = createAsyncThunk(
    'changeMRXStatus',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { data, id } = datas
            let requestApiUrl = '/user/update-pescriptionStatus/' + id;
            const response: any = await request('put', requestApiUrl, data);
            console.log("data", response.data.data)

            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const changeMRXExpiration: any = createAsyncThunk(
    'changeMRXExpiration',
    async (datas: any, { rejectWithValue }) => {
        try {
            const { data, id } = datas
            let requestApiUrl = '/user/update-pescriptionExpiration/' + id;
            const response: any = await request('put', requestApiUrl, data);
            return { data: response.data.data };
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const slice = createSlice({
    name: 'user',
    initialState,
    reducers: {
    },
    extraReducers: {
        // Add reducers for additional action types here, and handle loadingNotice state as needed
        [getUserList.fulfilled]: (state, action) => {
            const { data, total } = action.payload;
          
            state.userList = data;
            state.totalCount = total
        },
        [getUserList.pending]: (state, action) => {
        },
        [getUserList.rejected]: (state, action) => {

        },
        [getUserById.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedUser = data
            state.loadingUser = false;
        },
        [getUserById.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [getUserById.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [addPermission.fulfilled]: (state, action) => {
            const { data } = action.payload;
            console.log("action.payload", action.payload)
            state.selectedUser = data
            state.loadingUser = false;
        },
        [addPermission.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [addPermission.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [addUser.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedUser = data
            state.loadingUser = false;
        },
        [addUser.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [addUser.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [editUser.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.selectedUser = data
            state.loadingUser = false;
        },
        [editUser.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [editUser.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [changeStatus.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.userList = state.userList.map((user, index) => {
                if (user.user_id === data.user_id) {
                    return { ...user, active_status: data.active_status }
                }
                return user
            })
        },
        [changeStatus.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [changeStatus.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [changeMRXStatus.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.userList = state.userList.map((user, index) => {
                if (user.user_id === data.user_id) {
                    let bdf_pescription = user.bdf_pescription || {}
                    bdf_pescription.active_status_in_project = data.bdf_pescription.active_status_in_project
                    return { ...user, bdf_pescription: bdf_pescription }
                }
                return user
            })
        },
        [changeMRXStatus.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [changeMRXStatus.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        [changeMRXExpiration.fulfilled]: (state, action) => {
            const { data } = action.payload;
            state.userList = state.userList.map((user, index) => {
                if (user.user_id === data.user_id) {
                    let bdf_pescription = user.bdf_pescription || {}
                    bdf_pescription.membership_expiration_date = data.bdf_pescription.membership_expiration_date
                    bdf_pescription.membership_expiration_date_mobile = data.bdf_pescription.membership_expiration_date_mobile
                    return { ...user, bdf_pescription: bdf_pescription }
                }
                return user
            })
        },
        [changeMRXExpiration.pending]: (state, action) => {
            state.selectedUser = {}
            state.loadingUser = true;
        },
        [changeMRXStatus.rejected]: (state, action) => {
            state.loadingUser = false;

        },
        // [exportAllDataByType.fulfilled]: (state, action) => {
        //     console.log(action.payload)
        // },
        // [exportAllDataByType.pending]: (state, action) => {
        //     // state.selectedUser = {}
        //     // state.loadingUser = true;
        // },
        // [exportAllDataByType.rejected]: (state, action) => {
        //     // state.loadingUser = false;

        // },
    }
})




// export const { setNotice} = slice.actions;
export { getUserList, getUserById, addPermission, addUser, editUser, changeStatus, changeMRXStatus, changeMRXExpiration ,exportAllDataByType};
export default slice.reducer;
